import { useEffect } from 'react'
import { compose, hoc, useStore } from '@'
import { SetFormValues, useForm, useFormLoading } from '@form'
import GetCatalogs from '../../actions/GetCatalogs'
import GetSupplierCoverage from '../../actions/GetSupplierCoverage'
import { $coverageCatalogs, $supplierCoverageQuery } from '../../stores'

const container = compose(
    hoc(props => {
        const [catalogs, query] = useStore([$coverageCatalogs, $supplierCoverageQuery])

        useEffect(() => {
            GetCatalogs().catch(console.error)
        }, [])

        const [$props, $form] = useForm(() => {
            const onSubmit = async values => {
                await GetSupplierCoverage({ column: values.column, page: 1, page_size: 20 })
            }

            return {
                name: 'SupplierCoverageSearch',
                onSubmit
            }
        }, [])

        const $loading = useFormLoading($form.name)

        // A deep link (?column=hotelston_id) also lands in the select; paging does not touch it.
        const column = query && query.column
        useEffect(() => {
            if (column) {
                SetFormValues($form.name, { column })
            }
        }, [$form.name, column])

        return {
            $props,
            $loading,
            catalogs: catalogs || [],
            ...props
        }
    })
)

export default container
